<template>
  <el-form-item
    :label="titlize(label)"
    :rules="metaData.is_required ? requiredField() : []"
  >
    <el-checkbox-group
      :ref="`input-field-${formIndex}`"
      class="checkbox-collection"
      v-model="selectedOptions"
    >
      <el-checkbox
        class="chk-label chk-label-small"
        v-for="(option, i) in options"
        :key="i"
        :label="option"
        :disabled="preview"
        >{{ titlize(option) }}
      </el-checkbox>
    </el-checkbox-group>
    <div class="el-form-item__error">
      {{ errMsg }}
    </div>
  </el-form-item>
</template>

<script>
import { titleCase } from "@/lib/utils";

export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: [String, Array]
    },
    metaData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },
    parentForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      input: "",
      selectedOptions: [],
      errMsg: ""
    };
  },

  inject: ["preview"],

  computed: {
    setValue: {
      get() {
        return this.selectedOptions;
      },
      set(val) {
        this.$emit("update:value", val);
      }
    },
    preview() {
      return this.preview;
    }
  },
  methods: {
    titlize(option) {
      return titleCase(option);
    },

    validateInput() {
      if (!this.metaData.is_required && !this.selectedOptions.length) {
        return;
      }
      if (this.metaData.is_required && !this.selectedOptions.length) {
        this.errMsg = `${this.titlize(this.label)} is required`;
        this.$emit("isValid", false);
      } else {
        this.errMsg = "";
      }
    }
  },
  watch: {
    selectedOptions(val) {
      this.validateInput();
      this.setValue = val;
      setTimeout(() => {
        const chkButtons = document.querySelectorAll(
          ".checkbox-collection .el-checkbox .el-checkbox__inner"
        );
        chkButtons.forEach(button => {
          button.parentElement.nextSibling.style.color = "rgba(0,0,0,.86)";
          button.style.background = "none";
          button.style.borderColor = "#dcdfe6";
        });
      });

      setTimeout(() => {
        const chkButtonsChecked = document.querySelectorAll(
          ".checkbox-collection .el-checkbox__input.is-checked .el-checkbox__inner"
        );
        chkButtonsChecked.forEach(button => {
          button.parentElement.nextSibling.style.color = this.colors.secondary;
          button.style.background = this.colors.secondary;
          button.style.borderColor = this.colors.secondary;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-checkbox__input {
  top: 3px !important;
}
.chk-label {
  width: 45% !important;
  display: flex;
  float: left;
  margin: 0 10px 10px 0;
}

.checkbox-collection {
  clear: both;
  display: block;
  width: 100%;
}
.el-checkbox__label {
  white-space: normal !important;
}
.chk-label {
  line-height: 1.2;
  width: 150px;
}

@media (max-width: 1024px) {
  .chk-label {
    width: 48% !important;
    float: left;
    display: flex;
    margin-right: 1%;
  }
}

@media (max-width: 768px) {
  .chk-label {
    width: 48% !important;
    display: flex;
    float: left;
    margin-right: 1%;
  }
}

@media (max-width: 600px) {
  .chk-label {
    width: 98% !important;
    float: none;
    display: flex;
    margin-right: 1%;
  }
}
</style>
